import Isvg from 'react-inlinesvg'
import styled, { withTheme } from 'styled-components'

const getFill = props => {
  return props.inverted
    ? 'var(--clr-btn)'
    : 'var(--clr-black-to-main)'
}

const getBackgroundColor = props => {
  return props.inverted
    ? 'var(--clr-black-to-main)'
    : 'var(--clr-btn)'
}

const SVGIcon = styled(Isvg).attrs(props => ({
  src: props.src
}))`
  svg {
    fill: ${props => getFill(props)};
    background-color: ${props => getBackgroundColor(props)};

    &:hover {
      box-shadow: inset 0 0 100% 100% rgba(255, 255, 255, 0.1);
    }
  }
`

export default withTheme(SVGIcon)



// WEBPACK FOOTER //
// ./src/components/SVGIcon/index.js